import { ROLE_LABELS, type ShiftFilters } from "@/features/shifts/types";

interface Props {
  filters: ShiftFilters;
  onChange: (filters: ShiftFilters) => void;
}

interface Chip {
  key: keyof ShiftFilters;
  label: string;
}

export function ActiveFilters({ filters, onChange }: Props) {
  const chips: Chip[] = [];
  if (filters.role) chips.push({ key: "role", label: ROLE_LABELS[filters.role] });
  if (filters.date_from) chips.push({ key: "date_from", label: `From ${filters.date_from}` });
  if (filters.date_to) chips.push({ key: "date_to", label: `To ${filters.date_to}` });
  if (filters.min_pay) chips.push({ key: "min_pay", label: `≥ $${filters.min_pay}` });
  if (filters.city) chips.push({ key: "city", label: filters.city });

  if (chips.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs text-muted-foreground">Filters:</span>
      {chips.map((chip) => (
        <button
          key={chip.key}
          type="button"
          onClick={() => onChange({ ...filters, [chip.key]: undefined })}
          className="inline-flex items-center gap-1 rounded-full border bg-secondary px-2.5 py-0.5 text-xs font-medium text-secondary-foreground transition-colors hover:bg-secondary/80"
        >
          {chip.label}
          <span className="text-muted-foreground">×</span>
        </button>
      ))}
    </div>
  );
}
